import { render, staticRenderFns } from "./VirtupassPanel.vue?vue&type=template&id=ffdfe6c4&scoped=true"
import script from "./VirtupassPanel.vue?vue&type=script&lang=js"
export * from "./VirtupassPanel.vue?vue&type=script&lang=js"
import style0 from "./VirtupassPanel.vue?vue&type=style&index=0&id=ffdfe6c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffdfe6c4",
  null
  
)

export default component.exports